/**
 * セッションごとの参加 QR から来たときの「参加予定のセッション」を一時保存する (2026-09-04)。
 *
 * 旧2 `apps/user/src/App.tsx` の `OldUrlRedirect` + `OnboardingPage` の
 * `sessionStorage.getItem('pendingSessionId:{districtToken}')` を踏襲。v2 では未配線だった
 * (OnboardingPage の注記「sessionStorage pendingSessionId 連携も v2 では未配線のため省略」)。
 *
 * なぜ sessionStorage か:
 *   参加 QR (`/m/{urlToken}/join/{sessionId}`) を読んだ未参加者は、ユーザー設定 (onboarding) を
 *   経由してから参加するため、URL のセッション ID がその間に失われる。永続化する性質のものではなく
 *   (タブを閉じたら破棄でよい)、地区ごとに 1 件持てれば足りるため sessionStorage を使う。
 *   プライベートモード等で例外が出ても機能全体は成立するので、読み書きとも失敗は握り潰す。
 */

/** 地区ごとの保存キー (旧2 と同形式)。 */
export function pendingSessionKey(urlToken: string): string {
  return `pendingSessionId:${urlToken}`;
}

/** 参加予定のセッションを保存する。失敗しても致命的ではないので握り潰す。 */
export function savePendingSessionId(urlToken: string, sessionId: string): void {
  if (!urlToken || !sessionId) return;
  try {
    sessionStorage.setItem(pendingSessionKey(urlToken), sessionId);
  } catch {
    /* quota / privacy mode: 参加自体はできるので無視 */
  }
}

/** 参加予定のセッションを読む (無ければ null)。 */
export function loadPendingSessionId(urlToken: string | null | undefined): string | null {
  if (!urlToken) return null;
  try {
    const v = sessionStorage.getItem(pendingSessionKey(urlToken));
    return v && v.length > 0 ? v : null;
  } catch {
    return null;
  }
}

/** 使い終わった参加予定のセッションを消す (重複反映の防止、旧2 踏襲)。 */
export function clearPendingSessionId(urlToken: string | null | undefined): void {
  if (!urlToken) return;
  try {
    sessionStorage.removeItem(pendingSessionKey(urlToken));
  } catch {
    /* ignore */
  }
}
